import gql from 'graphql-tag';
import { OPERATIONS_INPUT } from './fragments';

export const FETCH_OPERATIONS = gql`
${OPERATIONS_INPUT}
query filteredOperations($input: FilteredOperationsInput) {
  filteredOperations(input: $input) {
    ...operation
  }  
}
`;

export const FETCH_OPERATIONS_OLD = gql`
${OPERATIONS_INPUT}  
query filteredOperations($filters: OperationsFiltersInput) {
  filteredOperations(input: {filters: $filters}) {
    ...operation
  }
}
`;

export const RENEW_OPERATION = gql`
mutation renewOperation(
  $input: CreateOperationInput
) {
  renewOperation(input: $input) {
    agent 
    agentCommission{
      quantity
      volume
      currency
    } 
    harold_number
    assignedTo{
      id
    }
    admin{
      id
    }
    billingEntity 
    cancellationReason 
    comment 
    company{
      id
    }
    companyReference 
    conditionning 
    consignee{
      id
    }
    consigneeCompanies{
      id
    } 
    consigneeSites{
      id
    }
    createdBy{
      id
    }
    dateOfCreation 
    
    division 
    endDate
    lastArrivalDate
    estimatedLogisticCost{
      currency
      quantity
      volume
    } 
    exchangeRate {
      rate
    }
    invoiceFollowUpStatus 
    goal{
      id
    }
   
    isApproved 
    isPartialShipmentAllowed 
    isPaymentReceived 
    isWM 
    limitPrice{
      currency
      quantity
      volume
    }
    letterOfCredit{
      id
    }
    logisticMaterial 
    margin{
      currency
      quantity
      volume
    }
    marketType 
    maturity{
      value
    }
    notifyParties{
      id
    }
    origin 
    otherCosts{
      quantity
    } 
    parentOperation{
      id
    }
    paymentPercentage 
    paymentTerms 
    photos 
    placeOfDelivery 
    portOfDestination 
    portOfLoading 
    priceCost{
      currency
      volume
      quantity
    }
    qualities{
      id
      price{
        currency
        quantity
        volume
      }
      quantity{
        quantity
        volume
      }
      mqc
      incoterm
      destination{
        id
      }
      indexName
      indexName2
      indexValue
      indexPeriod
      indexQpDays
      
    }       
    referenceNumber 
    shouldBeSentToContact 
    site{
      id
    }
    status 
    subdivision 
    targetCost{
      currency
      volume
      quantity
    }
    type 
    shipmentMode 
    maxNumberOfContainers 
    minNumberOfContainers 
    releaseType 
    releaseEvent 
    isWarehouse 
    status 
  }
}
`;